import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import { useHistory, useParams } from 'react-router-dom';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';

import * as helpers from './helpers.js'
import * as globals from './globals.js'
import * as Actions from './redux-actions.js'


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import SyncIcon from '@material-ui/icons/Sync';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';





export const simcards_columns = [
  { id: 'delete_this_row', label: '', minWidth: 100 },
  { id: 'id', label: 'ID', minWidth: 70 },
  { id: 'name', label: 'Simcard name', minWidth: 250 },
  { id: 'price_azn', label: 'AZN', minWidth: 90 },
  { id: 'price_eur', label: 'EUR', minWidth: 90 },
];




const useStyles = makeStyles((theme) => ({
  root: {
      width: "100%",
  },
  container: {
    maxWidth: "700px",
    maxHeight: props => props.maxHeight || 550,
  },
}));



function Simcards(props) {
  const { p1 } = useParams()
  const classes = useStyles()
  const history = useHistory()
  const serverStatus = useSelector(state => state.serverStatus)
  const authenticated = useSelector(state => state.authenticated)
  const current_role = useSelector(state => state.current_role)
  const simcards = useSelector(state => state.dictionary.sim_cards)
  
  const dispatch = useDispatch()
  const [loaded, setLoaded] = useState(true);
  const [apiCallInProgress, setApiCallInProgress] = useState(false);
  const [refresh, setRefresh] = useState(true)
  const [open, setOpen] = React.useState(false);
  

  useEffect(() => {
     
     if (serverStatus) {
       setLoaded(false)
       helpers.getAPI(
         { func: function(resp) {
                 dispatch({type: Actions.LOAD_DICTIONARY,  value: resp})
                 setLoaded(true)
               }, 
           uri: globals.myAPIurl+'/getdict'
         })

     }

  }, [refresh]);


  const refreshData = () => {
     setRefresh(!refresh)
  }


  if (! simcards ) return (<div className="section has-background-light">
                          <CircularProgress />
                        </div>)
  


  return (
  	<div>

     <AddSimcard open={open} onClose={()=>setOpen(false)}/>

     <div className="columns is-mobile">
       <div className="column is-10">
    
       <Button variant="contained" color="primary" onClick={() => setOpen(true)}>Add simcard</Button>

      </div>

     <div className="column is-2 has-text-right">
     
       <IconButton
        variant="contained"
        color="secondary"
        onClick={refreshData}>
         { (! loaded) ? <CircularProgress size={24} color="secondary"/> : <SyncIcon /> }
       </IconButton>
      
      </div>
    </div>

   
   
    <div className="columns">
      <div className="column">
        <div className="header is-size-7">&nbsp;</div>         
        <SimcardsTable data={simcards}/>
      </div>
     
    </div>

    </div>
  )

}

export default Simcards






function AddSimcard (props) {
  const containerClasses = useContentStyles()
  const dispatch = useDispatch()
  
  let addValueObj = {}

  const handleSave = () => {
    let addValueObjValues = helpers.mapElementToValue(addValueObj)

    helpers.postAPI(
         { func: function(data) {
              //After receiving response from server
              if (data.status === 'OK') {
                
                  dispatch({type: Actions.UPDATE_SIMCARD, insert: true, row: data.new_row})
                  props.onClose();

              } else {
                  helpers.closeMessage()
                  helpers.alertMessage('Error on server. '+data.message, globals.ERRO)
              }
          }, 
           uri: globals.myAPIurl+'/postdb',
           data: {what: "simcard",
                  id: addValueObjValues.id,
                  value: addValueObjValues}
         })
    
  };


  const handleClose = () => {
     props.onClose();
  };


  return (

      <Dialog open={props.open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Add SimCard</DialogTitle>
        <DialogContent className={containerClasses.root}>

            <div className="columns">

              <div className="column">
                <div class="field">   
                  <div class="control"> 
                    <TextField
                     id="add-simcard-id"
                     label="ID"
                     type="number"
                     inputRef = {(c)=>addValueObj.id = c}
                   />
                 </div>
                </div>
              </div>
              
              <div className="column">
                <div class="field">   
                  <div class="control"> 
                    <TextField
                     id="add-simcard-name"
                     label="Name"
                     type="text"
                     inputRef = {(c)=>addValueObj.name = c}
                   />
                 </div>
                </div>
              </div>

              <div className="column">
                <div class="field">   
                  <div class="control"> 
                    <TextField
                     id="add-simcard-azn"
                     label="Price AZN"
                     type="number"
                     inputRef = {(c)=>addValueObj.price_azn = c}
                   />
                 </div>
                </div>
              </div>

              <div className="column">
                <div class="field">   
                  <div class="control"> 
                    <TextField
                     id="add-simcard-eur"
                     label="Price EUR"
                     type="number"
                     inputRef = {(c)=>addValueObj.price_eur = c}
                   />
                 </div>
                </div>
              </div>


           </div>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>


    )


}





const useContentStyles = makeStyles((theme) => ({
  root: {
      overflowY: "initial",
  },

}));





export function SimcardsTable (props) {
  const classes = useStyles()
  const containerClasses = useContentStyles()
  const [open, setOpen] = React.useState(false);
  const [edit, setEdit] = React.useState({})
  const [Rows, setRows] = useState([])
  const dispatch = useDispatch()
  
  let editValueObj = {}

  useEffect(()=>{

   let tRows = props.data

   tRows.sort((a,b)=>{
    if (a.id < b.id) {
     return -1;
    }
    if (a.id > b.id) {
     return 1;
    }
     return 0;
   })

   setRows(tRows)

  }, [props.data])



  const editRow = (data) => {
    setEdit({...data})
    setOpen(true);
  };



  const handleSave = () => {

    let changeValueObj = helpers.mapElementToValue(editValueObj)

    helpers.postAPI(
         { func: function(data) {
              //After receiving response from server
              if (data.status === 'OK') {
                
                if (edit.column === "delete_this_row") {
                  dispatch({type: Actions.UPDATE_SIMCARD, delete: true, id: edit.id})

                } else {
                  dispatch({type: Actions.UPDATE_SIMCARD, update:edit.id, row: data.new_row})
                }

              } else {
                  helpers.closeMessage()
                  helpers.alertMessage('Error on server. '+data.message, globals.ERRO)
              }
          }, 
           uri: globals.myAPIurl+'/postdb',
           data: {what: "simcard",
                  ...edit,
                  value: changeValueObj}
         })

    setOpen(false);
  };


  const handleClose = () => {
    setOpen(false);
  };





  if (! Rows) return (<div></div>)


  return (
  <section>

      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{(edit.column) && simcards_columns.find((c)=>c.id===edit.column).label}</DialogTitle>
        <DialogContent className={containerClasses.root}>

            <div className="columns">

            { (edit.column === "delete_this_row") && 
              (
                <div className="column">
                <div class="field">   
                  <InputLabel>Are you sure?</InputLabel>
                </div>
                </div>
              )
            ||
               (
                <div className="column">
                <div class="field">   
                  <div class="control"> 
                    <TextField
                     id="simcards-val"
                     label="Value"
                     type={(typeof edit[edit.column] === "string") ? "text" : "number"}
                     defaultValue={edit[edit.column]}
                     inputRef = {(c)=>editValueObj[edit.column] = c}
                   />
                 </div>
                </div>
                </div>
               )
              }
              
              </div>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary">
            {(edit.column === "delete_this_row") ? "Yes" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>



     <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {simcards_columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Rows.map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                  {simcards_columns.map((column) => {

                    if (column.id === "delete_this_row") {
                       return (
                      <TableCell key={column.id} align={column.align} className={containerClasses.cell}>
                         <Button size="small" variant="contained" color="secondary" onClick={(e) => editRow({column: column.id, ...row})}>Delete</Button>
                      </TableCell>
                        )
                    }

                    const value = row[column.id];
                    return (
                      
                      <TableCell key={column.id} align={column.align} className={containerClasses.cell}>
                   
                         { (column.format) ? column.format(value) : value }
                         <IconButton color="primary" component="span" size="small">
                            <EditIcon fontSize="inherit" edge="end" onClick={(e) => editRow({column: column.id, ...row})}/>
                         </IconButton>
                         
                      </TableCell>
                      
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>


   </section>


    )


}





